<script lang="ts" setup>
import EpaperSuccessBlock from '@/components/epaper/EpaperSuccessBlock.vue'
</script>

<template>
  <div>
    <EpaperSuccessBlock />
  </div>
</template>
